const googleDriveUrlPattern = (pathSegment: string): RegExp =>
  new RegExp(
    `^https://docs\\.google\\.com/(?:a/[^/]+/)?${pathSegment}/d/([a-zA-Z0-9_-]+)`,
    'i',
  );

const GOOGLE_DOC_URL_PATTERN = googleDriveUrlPattern('document');
const GOOGLE_SLIDES_URL_PATTERN = googleDriveUrlPattern('presentation');

export const isGoogleDocUrl = (uri: string): boolean =>
  GOOGLE_DOC_URL_PATTERN.test(uri);

export const extractGoogleDocId = (uri: string): string | undefined =>
  uri.match(GOOGLE_DOC_URL_PATTERN)?.[1];

export const isGoogleSlidesUrl = (uri: string): boolean =>
  GOOGLE_SLIDES_URL_PATTERN.test(uri);

export const extractGoogleSlidesId = (uri: string): string | undefined =>
  uri.match(GOOGLE_SLIDES_URL_PATTERN)?.[1];
